import { Box, Chip, Sheet, Stack, Typography } from "@mui/joy";

/**
 * Таблица расшифровки суммы по одной роли.
 *
 * props:
 *  - rows: [{ kind: 'base'|'addon'|'transfer'|'total', label, formula, amount }]
 *  - title: подпись блока
 *  - accent: цвет акцента
 *  - compact: плотный режим (для раскрытия в строке таблицы)
 */
const KIND_COLOR = {
  base: "#6d28d9",
  addon: "#0891b2",
  transfer: "#ca8a04",
  total: "#15803d",
};

const KIND_LABEL = {
  base: "база",
  addon: "доп",
  transfer: "выезд",
  total: "итог",
};

export const fmtMoney = (v) =>
  Number(v || 0).toLocaleString("ru-RU", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

export default function PaymentBreakdown({ rows, title, accent = "#6d28d9", compact = false }) {
  if (!rows || rows.length === 0) {
    return (
      <Typography level="body-sm" sx={{ color: "text.tertiary", py: 1 }}>
        Расчёт не сохранён. Нажмите «Пересчитать», чтобы построить расшифровку.
      </Typography>
    );
  }

  return (
    <Sheet
      variant="soft"
      sx={{
        borderRadius: "14px",
        p: compact ? 1.25 : 2,
        background: "linear-gradient(180deg,#ffffff 0%,#fafafa 100%)",
        border: "1px solid #eceaf5",
      }}
    >
      {title && (
        <Typography level="title-sm" sx={{ color: accent, mb: 1 }}>
          {title}
        </Typography>
      )}

      <Stack spacing={compact ? 0.5 : 0.75}>
        {rows.map((row, idx) => {
          const isTotal = row.kind === "total";
          return (
            <Box
              key={idx}
              sx={{
                display: "flex",
                alignItems: "flex-start",
                justifyContent: "space-between",
                gap: 1.5,
                pt: isTotal ? 0.75 : 0,
                borderTop: isTotal ? "1px solid #e6e3f0" : "none",
              }}
            >
              <Box sx={{ minWidth: 0, flex: 1 }}>
                <Stack direction="row" spacing={0.75} alignItems="center" sx={{ flexWrap: "wrap" }}>
                  {!isTotal && (
                    <Chip
                      size="sm"
                      variant="soft"
                      sx={{
                        fontSize: "0.65rem",
                        "--Chip-minHeight": "18px",
                        color: KIND_COLOR[row.kind] || "#555",
                        bgcolor: `${KIND_COLOR[row.kind] || "#555"}14`,
                      }}
                    >
                      {KIND_LABEL[row.kind] || row.kind}
                    </Chip>
                  )}
                  <Typography
                    level={isTotal ? "title-sm" : "body-sm"}
                    sx={{ fontWeight: isTotal ? 700 : 500 }}
                  >
                    {row.label}
                  </Typography>
                </Stack>
                {row.formula ? (
                  <Typography level="body-xs" sx={{ color: "text.tertiary", mt: 0.15 }}>
                    {row.formula}
                  </Typography>
                ) : null}
              </Box>

              <Typography
                level={isTotal ? "title-sm" : "body-sm"}
                sx={{
                  whiteSpace: "nowrap",
                  fontWeight: isTotal ? 800 : 600,
                  color: isTotal ? KIND_COLOR.total : "text.primary",
                }}
              >
                {fmtMoney(row.amount)} ₽
              </Typography>
            </Box>
          );
        })}
      </Stack>
    </Sheet>
  );
}